import ContactBlock, { ContactHeading } from "../components/ContactBlock";

export default function Contatti() {
  return (
    <div data-testid="contatti-page">
      <section className="bg-white pb-24 pt-40 sm:pb-32" data-testid="contact-section">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <ContactHeading />
          <div className="mt-14">
            <ContactBlock />
          </div>
        </div>
      </section>
    </div>
  );
}
